import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { colors } from '@guryou/colors';
import { useEffectOnce } from '@guryou/hooks';
import { Block, FlexColumn, FlexRow, Image, LargeText, MediumText, PaperBlock, Spinner } from '@guryou/html-components';
import { getProviderGeneralInformation, getProviderLatestWidget, stateIsLoaded, stateIsNotInitialized } from '@guryou/redux';
import Chip from '@material-ui/core/Chip';
import WidgetContainer from 'modules/widget';
import Carousel from './Carousel';
import CarouselSlide from './ProviderImagesCarousel';

const tabletWidth = 900;

const colorsBadge = [
  {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
  },
  {
    bg: 'bg-green-100',
    text: 'text-green-800',
  },
  {
    bg: 'bg-red-100',
    text: 'text-red-800',
  },
  {
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
  },
  {
    bg: 'bg-purple-100',
    text: 'text-purple-800',
  },
  {
    bg: 'bg-pink-100',
    text: 'text-pink-800',
  },
  {
    bg: 'bg-teal-100',
    text: 'text-teal-800',
  },
  {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
  },
  {
    bg: 'bg-indigo-100',
    text: 'text-indigo-800',
  },
  {
    bg: 'bg-gray-100',
    text: 'text-gray-800',
  },
];

const Provider = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const width = window.innerWidth;

  const providerDetails = useSelector(state => state.generalInfo);
  const widget = useSelector(state => state.providerLatestWidget);

  const i18nCheck = t('GENERAL.actions');

  useEffectOnce(() => {
    if (['Actions', 'Azioni'].includes(i18nCheck)) {
      if (stateIsNotInitialized(providerDetails) && stateIsNotInitialized(widget)) {
        dispatch(getProviderGeneralInformation(true, +params.id));
        dispatch(getProviderLatestWidget(+params.id));
      }
    }

    //eslint-disable-next-line
  }, [i18nCheck]);

  if (!stateIsLoaded(providerDetails) || !stateIsLoaded(widget)) {
    return <Spinner />;
  }

  return (
    <section class="py-16 pt-40">
      <div class="container mx-auto px-4">
        <div class={`bg-[${colors.mineShaft}] rounded-lg shadow-lg p-6`}>
          <img
            src={providerDetails?.data?.images[0]?.xLarge || providerDetails?.data?.images[0]?.large || providerDetails?.data?.images[0]?.medium}
            alt="Dashboard mockup"
            class="rounded-md mx-auto block w-[800px] h-[400px] object-cover object-center "
          />
        </div>

        <div class="mt-10">
          <h1 class="text-4xl font-bold mb-2">{providerDetails?.data?.name}</h1>
          <div class="flex flex-wrap mb-4">
            {providerDetails.data?.categories &&
              providerDetails.data?.categories.length &&
              providerDetails.data?.categories.map((item, index) => {
                const color = colorsBadge[index % colorsBadge.length]; // Seleciona uma cor com base no índice
                return (
                  <span key={index} className={`text-xs font-medium me-2 px-2.5 py-1 rounded-full ${color.bg} ${color.text}`}>
                    {item.name}
                  </span>
                );
              })}
          </div>
          <p class="text-gray-600 mb-6">
            {providerDetails.data?.address && (
              <p>
                {t('GENERAL.address')}: {providerDetails.data.address}
              </p>
            )}

            {providerDetails.data?.email && (
              <p>
                {t('GENERAL.email')}:{' '}
                <a href={`mailto:${providerDetails.data.email}`} className="text-blue-400 underline">
                  {providerDetails.data.email}
                </a>
              </p>
            )}

            {providerDetails.data?.phone && (
              <p>
                {t('GENERAL.phone')}: {providerDetails.data.phone}
              </p>
            )}
          </p>
        </div>

        <div class="mt-10">
          <p class="text-gray-600 mb-4">{providerDetails.data?.description}</p>
        </div>
        <WidgetContainer widgetId={widget?.data?.id} />
      </div>
    </section>
  );

  {
    /* return (
    <>
      <Block height={200} backgroundColor={colors.mineShaft} margin={0} position="absolute" zIndex={-1}></Block>
      <Block xs={width < tabletWidth ? 11 : 8} margin="auto" height={110}>
        <LargeText
          fontSize={width < tabletWidth ? '1.6rem' : '2.5rem'}
          fontWeight={700}
          color={colors.white}
          marginTop={12}
          marginLeft={2}
          textShadow="3px 3px 3px rgba(0,0,0,0.2)"
        >
          {providerDetails?.data?.name}
        </LargeText>
      </Block>
      <FlexColumn xs={width < tabletWidth ? 10 : 8} boxShadow="0 0 10px rgba(0,0,0,0.3)" position="relative" marginBottom={15} marginTop={2}>
        <Block maxHeight={500} margin={0}>
          <Image
            height="auto"
            xs={12}
            src={providerDetails?.data?.images[0]?.xLarge || providerDetails?.data?.images[0]?.large || providerDetails?.data?.images[0]?.medium}
            verticalAlign="middle"
            objectFit="cover"
          />
        </Block>
        <PaperBlock display="flex" flexDirection={width < 650 ? 'column' : 'row'} justifyContent="space-between" xs={12} padding={2}>
          <FlexColumn xs={width < 650 ? 12 : 6}>
            <Block xs={12}>
              <MediumText>{t('PROFILE.categories')}</MediumText>
            </Block>
            <FlexRow xs={12}>
              {providerDetails.data?.categories &&
                providerDetails.data?.categories.length &&
                providerDetails.data?.categories.map((x, i) => (
                  <Block width="fit-content" key={i}>
                    <Chip label={x.name} size="medium" color="secondary" />
                  </Block>
                ))}
            </FlexRow>
          </FlexColumn>
          <FlexColumn
            xs={width < 650 ? 12 : 6}
            marginLeft="auto"
            padding={1}
            alignItems={width < 650 ? 'flex-start' : 'flex-end'}
            padddingTop={2}
            paddingRight={2}
          >
            <MediumText fontWeight="700" textAlign={width < 650 ? 'left' : 'right'} fontSize="1.3rem">
              {t('GENERAL.address')}: {providerDetails.data?.address}
            </MediumText>
            <FlexRow justifyContent={width < 650 ? 'flex-start' : 'flex-end'}>
              {providerDetails.data?.email && (
                <Block width="fit-content">
                  <Chip label={providerDetails.data?.email} size="medium" color="secondary" />
                </Block>
              )}
              {providerDetails.data?.phone && (
                <Block width="fit-content">
                  <Chip label={providerDetails.data?.phone} size="medium" color="secondary" />
                </Block>
              )}
            </FlexRow>
          </FlexColumn>
        </PaperBlock>

        <PaperBlock xs={12} marginBot={2}>
          <Carousel CarouselSlide={<CarouselSlide images={providerDetails.data?.images} />} totalSlides={10} width={width} />
        </PaperBlock>

        <PaperBlock xs={12} textAlign="center" padding={2}>
          <MediumText>{providerDetails.data?.description}</MediumText>
        </PaperBlock>

        <PaperBlock xs={12} padding={2} height="500px">
          <WidgetContainer widgetId={widget?.data?.id} />
        </PaperBlock>
      </FlexColumn>
    </>
  ); */
  }
};

export default Provider;
